export enum PageUrlSegment {
  HOMEPAGE = '',
  REDEEMCASH_DETAILS = '/redeem_cash/checkout',
  REDEEMCASH_REVIEW = '/redeem_cash/review',
  REDEEMCASH_SUCCESS = '/redeem_cash/success',
  REDEEMCASH_ENROLLMENT = '/redeem_cash/checkout/enrollment',
  REDEEMCASH_AUTOREDEMPTION = 'redeem_cash/checkout/auto-redemption/enrollment',
  REDEEMCASH_AUTOREDEMPTION_SUCCESS = '/redeem_cash/checkout/auto-redemption/success',
  GIFTCARD_LIST = '/gift_card/listing',
  GIFTCARD_DETAILS = '/gift_card/checkout',
  GIFTCARD_REVIEW = '/gift_card/review',
  GIFTCARD_SUCCESS = '/gift_card/success',
  GIFTCARD_AUTOREDEMPTION = '/gift_card/checkout/auto-redemption',
  GIFTCARD_AUTOREDEMPTION_SUCCESS = '/gift_card/checkout/auto-redemption/success',
  TRANSFER_LANDING = '/transfer/checkout',
  TRANSFER_ADD_MEMBERSHIP = '/transfer/checkout/membership',
  TRANSFER_REVIEW = '/transfer/review',
  TRANSFER_PROGRAMS = '/transfer/programs',
  TRANSFER_SUCCESS = '/transfer/success',
  TRANSFER_AUTOREDEMPTION = '/transfer/checkout/auto-redemption',
  TRANSFER_AUTOREDEMPTION_SUCCESS = '/transfer/checkout/auto-redemption/success',
  POINTS_TRANSACTIONS = '/points_activity',
  ORDERS = '/orders',
  PAST_ORDERS = '/orders/past-redemptions',
  MANAGE_REDEMPTIONS = '/orders/manage-auto-redemptions',
  CONTACT_US = '/contact_us',
  FAQ = '/faq',
  TERMS = '/terms_of_use',
  SECURITY_AND_PRIVACY_STATEMENT = '/privacy_policy',
  SELECT_CARD = '/select-card',
  LATEST_UPDATES = '/latest-updates',
  CAMPAIGN_PAGE = '/campaign-page',
  MERCHANDISE = '/merchandise',
  MERCHANDISE_ALL = '/merchandise/all',
  MERCHANDISE_TOP_50 = '/merchandise/top_50',
  MERCHANDISE_CATEGORY = '/merchandise/category',
  MERCHANDISE_DETAILS = '/merchandise/details',
  SHOPPING_CART_DELIVERY = '/shopping-cart/delivery',
  SHOPPING_CART_PAYMENT = '/shopping-cart/payment',
  SHOPPING_CART_HOME = '/shopping-cart/payment',
  EVERYDAY_SPEND_CHECKOUT = '/everyday_rewards/checkout',
  EVERYDAY_SPEND_REVIEW = '/everyday_rewards/review',
  EVERYDAY_SPEND_SUCCESS = '/everyday_rewards/success',
  EVERYDAY_SPEND_AUTOREDEMPTION = '/everyday_rewards/checkout/auto-redemption',
  EVERYDAY_SPEND_AUTOREDEMPTION_SUCCESS = '/everyday_rewards/checkout/auto-redemption/success',
}
